import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import {SafeAreaView} from 'react-native-safe-area-context';
import {Alert, ScrollView, TouchableOpacity, View} from 'react-native';
import CheckBox from 'src/Modules/Native/CheckBox';

import useWindowDimensionsSafe from 'src/Modules/Native/useWindowDimensionsSafe';

import {
  BodyText,
  ContinueButton,
  CloseIconButton,
} from 'src/Modules/CommonView';
import QRCode from 'react-native-qrcode-svg';

import {addChildUser} from 'src/Utils/huntFunctions';
import AddToDeviceModal from 'src/Modules/CommonGame/AddToDeviceModal';

import {socialShare} from 'src/Utils/shareHelper';
import {navigationRef} from 'src/Nav/navigationHelpers';
import useParams from '../../Hooks/useParams';
import {useUserId, useUserInfo} from '../../Hooks/reduxHooks';

const AddPlayerModal = () => {
  const {width} = useWindowDimensionsSafe();

  const userId = useUserId();
  const [showAddPlayers, setShowAddPlayers] = useState(0);
  const [paidTickets, setPaidTickets] = useState(0);
  const groupInfo = useSelector((state) => state?.groupInfo);

  const {prepaidJoinCode, joinCode, eventId, huntStarted = false} = useParams();
  const playTestState = useSelector((state) => state.app_info?.playTestState);

  const joinLink = joinCode;
  const prepaidLink = prepaidJoinCode;

  let tickets = 0;
  const userTickets = useUserInfo('tickets');
  if (groupInfo?.theme && userTickets?.[groupInfo?.theme]) {
    tickets = userTickets?.[groupInfo?.theme];
  }

  /// new ticket purchase functionality
  const navigateToTicketsModal = () => {
    navigationRef.navigate('PurchaseModal', {
      theme: groupInfo?.theme,
    });
  };

  const toggleType = () => {
    console.log('toggling add players modal');

    if (!tickets || tickets < 1) {
      Alert.alert(
        'You Need Tickets',
        'You need tickets to let people join with your tickets.',
        [
          {
            text: 'Purchase Tickets',
            onPress: () => {
              navigateToTicketsModal();
            },
          },
          {
            text: 'Cancel',
          },
        ],
      );
    } else {
      setPaidTickets(!paidTickets);
    }
  };

  console.log('rendering add players modal');

  const easyUserLevelJoinCode = useUserInfo('easyUserLevelJoinCode');

  const {easyGroupLevelJoinCode, groupId, theme = ''} = groupInfo;

  console.log('the easy join codes are: ', {
    easyGroupLevelJoinCode,
    easyUserLevelJoinCode,
  });

  if (
    groupInfo &&
    groupInfo?.theme &&
    tickets?.[groupInfo?.theme] !== undefined
  ) {
    tickets = tickets?.[groupInfo?.theme];
  }

  const isFree = groupInfo?.huntId == '2266';

  const players = groupInfo?.players || {};
  const isPass = groupInfo?.passId;
  const passPlayers = groupInfo?.passPlayers || 0;
  const canJoinWithPass = isPass && Object.values(players).length < passPlayers;
  //const canJoinWithPass = isPass;

  let groupNeedsTicketsToJoin =
    playTestState == false &&
    groupInfo &&
    !eventId &&
    !isFree &&
    !theme?.includes?.('home') &&
    !canJoinWithPass;

  if (groupInfo?.indoor_hunt) {
    groupNeedsTicketsToJoin = false;
  }
  var displayedCode = joinCode;
  var displayedLink = joinLink || joinCode;
  var checked = false;
  if (groupNeedsTicketsToJoin && tickets > 0 && paidTickets) {
    displayedCode = prepaidJoinCode;
    displayedLink = prepaidLink || prepaidJoinCode;
    checked = true;
  }

  let qrCode = displayedCode;
  if (paidTickets && easyUserLevelJoinCode) {
    qrCode = `${easyUserLevelJoinCode}?c=${userId}`;
  } else if (easyGroupLevelJoinCode) {
    qrCode = `${easyGroupLevelJoinCode}?c=${groupId}`;
  }
  return (
    <SafeAreaView style={{flex: 1, justifyContent: 'flex-end'}}>
      <TouchableOpacity
        style={{flex: 1}}
        onPress={() => navigationRef.goBack(null)}
      />
      <View
        style={{
          minHeight: 400,
          width,
          borderRadius: 10,
          backgroundColor: global?.color?.white,
          position: 'relative',
        }}>
        <ScrollView>
          <View
            style={{
              alignItems: 'center',
              position: 'relative',
            }}>
            <BodyText
              text={'Add players'}
              textStyle={{
                marginTop: 20,
                marginHorizontal: 30,
                fontWeight: '700',
                marginBottom: 0,
                fontSize: 20,
                lineHeight: 20,
              }}
              center
            />

            <BodyText
              text={
                'Have them scan this QR code or choose from the available options below.'
              }
              textStyle={{
                marginHorizontal: 30,
              }}
              center
            />
            <View style={{height: 30, width}} />
            <QRCode
              value={qrCode || displayedLink || ' '}
              logo={require('src/Images/stickerLogo.png')}
              logoBackgroundColor="transparent"
              size={140}
              logoSize={30}
              logoBorderRadius={0}
              ecl={'M'}
              color={global?.color?.gray3}
            />
            {!!groupNeedsTicketsToJoin && (
              <TouchableOpacity
                style={{
                  alignItems: 'center',
                  flexDirection: 'row',
                  marginHorizontal: 30,
                  marginTop: 5,
                  height: 60,
                }}
                onPress={() => {
                  toggleType();
                }}>
                <CheckBox
                  checkBoxColor={global?.color?.gray2}
                  value={checked}
                  onValueChange={() => toggleType()}
                  style={{width: 15, height: 15}}
                />
                <BodyText
                  text={'Let Added Players use my tickets.'}
                  textStyle={{
                    marginBottom: 20,
                    marginTop: 15,
                    fontWeight: '700',
                  }}
                  center
                />
              </TouchableOpacity>
            )}
            <View style={{height: 20, width}} />
            {
              //////////WIP
            }
            <ContinueButton
              text={`Share Invite Code: ${displayedCode}`}
              containerStyle={{minWidth: 300, height: 50}}
              handlePress={() => {
                socialShare(
                  {
                    description: 'Join My Scavenger Hunt',
                    url:
                      `Join my scavenger hunt by entering this code ${displayedLink} in the Let's Roam App link on your phone or follow this link: ` +
                      qrCode,
                    userId: userId || '',
                    thumbnail: null,
                  },
                  'AddPlayerModal',
                  'scavaHunt',
                );
              }}
              background={global?.color?.orange}
            />
            {!!groupNeedsTicketsToJoin && (
              <BodyText
                text={`Tickets: ${tickets}`}
                textStyle={{fontWeight: '700'}}
                center
              />
            )}
            <ContinueButton
              text={'Add Players To Your Device'}
              background={global?.color?.gray3}
              containerStyle={{minWidth: 300, height: 50}}
              handlePress={() => {
                if (!!groupNeedsTicketsToJoin && (!tickets || tickets < 1)) {
                  return navigateToTicketsModal();
                }
                navigationRef.navigate('ConfirmModal', {
                  handleConfirm: async () => {
                    navigationRef.goBack(null);
                    setShowAddPlayers(1);
                  },
                  confirmText: 'Add Player To this Device',
                  confirmColor: global?.color?.orange,
                  cancelText: 'Cancel',
                  titleText: 'Are you sure? ',
                  titleBodyText:
                    'For the best scavenger hunt experience, we recommend that you play on multiple devices. That way each player gets to compete to answer location challenges.',
                });
              }}
            />
          </View>
          {!!groupInfo && !!eventId && !!groupInfo?.voucher_code && (
            <BodyText
              text={`Remember, players can create their own group as part of the event by entering the code: ${
                groupInfo?.voucher_code || 'No Code Found'
              }`}
              textStyle={{fontWeight: '700'}}
              center
            />
          )}
        </ScrollView>
        <CloseIconButton
          handlePress={() => navigationRef.goBack(null)}
          side="right"
        />
      </View>
      <AddToDeviceModal
        isVisible={showAddPlayers}
        groupInfo={groupInfo}
        groupId={groupInfo?.groupId}
        closeModal={() => setShowAddPlayers(0)}
        addChildUser={(firstName, parentUserId, parentUserEmail, groupId) => {
          addChildUser(firstName, parentUserId, parentUserEmail, groupId);
          if (huntStarted) {
            navigationRef.navigate('ScavengerHuntCharacterSelection');
          } else {
            navigationRef.goBack(null);
          }
        }}
        handleShopPress={() => navigationRef.navigate('PurchaseModal')}
      />
    </SafeAreaView>
  );
};

//eslint-disable-next-line
export default AddPlayerModal;
